import Immutable, { type ImmutableObject } from 'seamless-immutable'
import { createActions, createReducer } from 'reduxsauce'
import type {
  GetLatestWbiSuccessPayload,
  GetRecommendationsSuccessPayload,
  WellBeingState,
} from 'APP/Store/WellBeingAssessment/types'

/* ------------- Types and Action Creators ------------- */

const actionDefs = {
  getLatest: [],
  getLatestSuccess: ['assessment'],
  getLatestFailure: [],

  getRecommendations: [],
  getRecommendationsSuccess: ['recommendations'],
  getRecommendationsFailure: [],
} as const satisfies Record<string, string[]>

type TActions = typeof actionDefs
type TPayloads = {
  getLatestSuccess: GetLatestWbiSuccessPayload
  getRecommendationsSuccess: GetRecommendationsSuccessPayload
}

const { Types, Creators } = createActions<TPayloads, TActions>(actionDefs)

export const WellBeingTypes = Types
export default Creators

type ImmutableWellBeingState = ImmutableObject<WellBeingState>

export const INITIAL_STATE = Immutable<WellBeingState>({
  latest: {
    loading: true,
    data: null,
  },
  recommendations: {
    loading: false,
    retry: false,
    data: [],
  },
})

/* ------------- Reducers ------------- */
export const getLatest = (state: ImmutableWellBeingState) =>
  state.merge({
    latest: {
      loading: true,
      data: null,
    },
  })

export const getLatestSuccess = (
  state: ImmutableWellBeingState,
  { assessment }: { assessment: WellBeingState['latest']['data'] }
) =>
  state.merge({
    latest: {
      loading: false,
      data: assessment,
    },
  })

export const getLatestFailure = (state: ImmutableWellBeingState) =>
  state.merge({
    latest: {
      loading: false,
    },
  })

export const getRecommendations = (state: ImmutableWellBeingState) =>
  state.merge({
    recommendations: {
      loading: true,
      retry: false,
      data: state.recommendations.data,
    },
  })

export const getRecommendationsSuccess = (
  state: ImmutableWellBeingState,
  { recommendations }: { recommendations: WellBeingState['recommendations']['data'] }
) =>
  state.merge({
    recommendations: {
      loading: false,
      retry: false,
      data: recommendations,
    },
  })

export const getRecommendationsFailure = (state: ImmutableWellBeingState) =>
  state.merge({
    recommendations: {
      loading: false,
      retry: true,
    },
  })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer<TPayloads, TActions, ImmutableWellBeingState>(INITIAL_STATE, {
  [Types.GET_LATEST]: getLatest,
  [Types.GET_LATEST_SUCCESS]: getLatestSuccess,
  [Types.GET_LATEST_FAILURE]: getLatestFailure,

  [Types.GET_RECOMMENDATIONS]: getRecommendations,
  [Types.GET_RECOMMENDATIONS_SUCCESS]: getRecommendationsSuccess,
  [Types.GET_RECOMMENDATIONS_FAILURE]: getRecommendationsFailure,
})
